/**
 * @Class Key
 *
 * A Key Value Type abstraction to be used with {Keyboard}.
 */
export default class Key {
  public key: string;

  /**
   * Keyboard Key abstraction
   *
   * @param {String} keyValue - The MDN Key Identifier
   * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
   */
  constructor(keyValue) {
    this.key = keyValue;
  }

  /**
   *
   * @param {Key} other
   * @returns {boolean}
   */
  equals(other) {
    return other instanceof Key && (this.key === other.key);
  }

  didFire(event: KeyboardEvent) {
    return event && (this.equals(new Key(event.key)) || this.key === 'ANY');
  }

  didFireWithShift(event: KeyboardEvent) {
    return event && event.shiftKey && (this.equals(new Key(event.key)) || this.key === 'ANY');
  }

  static get press() {
    return 'keypress';
  }

  static get down() {
    return 'keydown';
  }

  static get up() {
    return 'keyup';
  }

  static get any() {
    return new Key('ANY');
  }

  static get esc() {
    return new Key('Escape');
  }

  static get enter() {
    return new Key('Enter');
  }

  static get space() {
    return new Key(' ');
  }

  static get tab() {
    return new Key('Tab');
  }

  static get shift() {
    return new Key('Shift');
  }

  static get arrowLeft() {
    return new Key('ArrowLeft');
  }

  static get arrowRight() {
    return new Key('ArrowRight');
  }

  static get arrowUp() {
    return new Key('ArrowUp');
  }

  static get arrowDown() {
    return new Key('ArrowDown');
  }

  static get home() {
    return new Key('Home');
  }

  static get end() {
    return new Key('End');
  }

  static get backspace() {
    return new Key('Backspace');
  }

  static get del() {
    return new Key('Delete');
  }

  static get clear() {
    return new Key('Clear');
  }
}
